export default __webpack_public_path__ + "static/media/Saturday_06.81409de5.png";